import { getConsumer } from './cable'
import { useTicketsStore } from '@/stores/tickets'
import { useBoardStore } from '@/stores/board'
import { useAuthStore } from '@/stores/auth'
import { useNotificationsStore } from '@/stores/notifications'

let subscription = null
let connectedOnce = false

export function startRealtime() {
  if (subscription) return
  connectedOnce = false
  subscription = getConsumer().subscriptions.create('TicketsChannel', {
    // Dispara no connect inicial E em toda reconexão (restart do server, rede,
    // deploy). Broadcast perdido enquanto o socket estava caído não é
    // re-entregue — então na reconexão ressincroniza o que já está carregado.
    connected() {
      if (connectedOnce) resync()
      connectedOnce = true
    },
    received: handle,
  })
}

export function stopRealtime() {
  subscription?.unsubscribe()
  subscription = null
}

function resync() {
  const board = useBoardStore()
  if (board.loaded) board.fetch()
  useTicketsStore().resync()
  useNotificationsStore().fetch()
}

function handle(data) {
  const tickets = useTicketsStore()
  const auth = useAuthStore()

  if (data.event === 'ticket.changed') {
    tickets.applyRealtime(data.ticket, auth)
    useBoardStore().applyRealtime(data.ticket)
  } else if (data.event === 'ticket.commented') {
    tickets.refreshIfCurrent(data.ticket_id)
  } else if (data.event === 'notification.new') {
    useNotificationsStore().addRealtime(data.notification)
  }
}
